export interface ReportAnalytics {
  pageViews?: number;
  visitors?: number;
  bounceRate?: number;
  avgVisitDuration?: number;
}

export interface ReportLead {
  name: string;
  email?: string;
  phone?: string;
  service?: string;
  status?: string;
  createdAt?: string;
}

export interface ReportReview {
  name?: string;
  rating?: number;
  text?: string;
  reviewDate?: string;
}

interface SiteInfo {
  businessName?: string;
  domain: string;
  trade?: string;
  leadsCount?: number;
  newLeadsCount?: number;
  reviewsCount?: number;
  avgRating?: number;
}

export function generateReport(
  site: SiteInfo,
  analytics: ReportAnalytics | null,
  leads: ReportLead[],
  reviews: ReportReview[],
  month: string,
) {
  const lines: string[] = [];
  lines.push(`Monthly Report — ${site.businessName || site.domain}`);
  lines.push(`Period: ${month}`);
  lines.push(`Domain: ${site.domain}`);
  lines.push('');

  if (analytics) {
    lines.push('--- Analytics ---');
    if (analytics.pageViews != null) lines.push(`Page Views: ${analytics.pageViews}`);
    if (analytics.visitors != null) lines.push(`Visitors: ${analytics.visitors}`);
    if (analytics.bounceRate != null) lines.push(`Bounce Rate: ${analytics.bounceRate}%`);
    lines.push('');
  }

  lines.push(`Total Leads: ${site.leadsCount ?? 0}`);
  lines.push(`New Leads: ${site.newLeadsCount ?? 0}`);
  lines.push(`Reviews: ${site.reviewsCount ?? 0}`);
  lines.push(`Avg Rating: ${site.avgRating ?? 'N/A'}`);
  lines.push('');

  if (leads.length > 0) {
    lines.push('--- Recent Leads ---');
    leads.forEach(l => lines.push(`  ${l.name} — ${l.status || 'new'}`));
    lines.push('');
  }

  if (reviews.length > 0) {
    lines.push('--- Recent Reviews ---');
    reviews.forEach(r => lines.push(`  ${r.name || 'Anonymous'} (${r.rating ?? '?'}★): ${(r.text || '').slice(0, 80)}`));
  }

  const blob = new Blob([lines.join('\n')], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `report-${site.domain}-${month}.txt`;
  a.click();
  URL.revokeObjectURL(url);
}
